import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { FaCheckCircle, FaPercentage, FaThumbsUp, FaTimes, FaTrash, FaEdit, FaSortAmountUp, FaSortAmountDown, FaArrowLeft, FaArrowRight, FaSearch, FaRedo, FaCog, FaHandshake, FaCogs, FaInfoCircle, FaMoneyBill, FaHistory, FaList, FaUser } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';

const ListeSouscriptionsAdmin = ({ titre }) => {
    useAuth();
    const [souscriptions, setSouscriptions] = useState([]);
    const [selectedSouscription, setSelectedSouscription] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [activeTab, setActiveTab] = useState('info');

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = souscriptions.length;

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Souscriptions";
            fetchSouscriptions();
        }
    }, [user_id]);

    // Fetch souscriptions data
    const fetchSouscriptions = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-souscriptions-admin/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setSouscriptions(data.souscriptions);
            } else {
                console.error('Erreur lors de la récupération des souscriptions');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    const handleRowClick = (souscription) => {
        setSelectedSouscription(souscription);
    };

    const handleCloseDetailModal = () => setShowDetailModal(false);

    // Filter souscriptions by search term
    const filteredSouscriptions = souscriptions.filter(s =>
        (s.utilisateur?.nom && s.utilisateur.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.utilisateur?.prenoms && s.utilisateur.prenoms.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.formation?.nom && s.formation.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.produit?.nom && s.produit.nom.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (s.date_souscription && s.date_souscription.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // Sort souscriptions
    const sortedSouscriptions = [...filteredSouscriptions].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'descending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastSouscription = currentPage * itemsPerPage;
    const indexOfFirstSouscription = indexOfLastSouscription - itemsPerPage;
    const currentSouscriptions = sortedSouscriptions.slice(indexOfFirstSouscription, indexOfLastSouscription);
    const totalPages = Math.ceil(sortedSouscriptions.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleShowDetail = async (souscription) => {
        setSelectedSouscription(souscription);
        setDetailData(souscription);
        setShowDetailModal(true);
    };



    const handleJournalPaiement = (souscription) => {
        navigate('/Journal-paiement', {
            state: {
                souscription_id: souscription.id,
            }
        });
    };

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Souscription")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaMoneyBill size={25} className='mr-2' /> Liste des souscriptions
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Souscriptions`}> Souscriptions</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="justify-content-center align-items-center mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="justify-content-center align-items-center">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Souscriptions des utilisateurs</h5>
                                <div className='d-flex'>
                                    <button
                                        onClick={() => selectedSouscription && handleShowDetail(selectedSouscription)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedSouscription ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedSouscription}
                                    >
                                        <FaInfoCircle />
                                        <span className="d-none d-sm-inline ml-1">
                                            Détail
                                        </span>
                                    </button>
                                    <button
                                        onClick={() => selectedSouscription && handleJournalPaiement(selectedSouscription)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedSouscription ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedSouscription}
                                    >
                                        <FaMoneyBill />
                                        <span className="d-none d-sm-inline ml-1">
                                            Journal paiements
                                        </span>
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                                    <span
                                        onClick={fermerNotif}
                                        style={{
                                            position: 'absolute',
                                            top: '0px',
                                            right: '10px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i className='fa fa-close'></i>
                                    </span>
                                </div>
                            )}
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <div className="input-group" style={{ width: '300px' }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('utilisateur.nom')}>
                                                                Utilisateur {sortConfig.key === 'utilisateur.nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('formation.nom')}>
                                                                Elémént {sortConfig.key === 'formation.nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('date_souscription')}>
                                                                Date souscription {sortConfig.key === 'date_souscription'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('montant_paye')}>
                                                                Montant payé {sortConfig.key === 'montant_paye'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='text-secondary d-none d-md-table-cell' onClick={() => handleSort('reste_a_payer')}>
                                                                Reste à payer {sortConfig.key === 'reste_a_payer'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentSouscriptions.length > 0 ? currentSouscriptions.map((souscription) => (
                                                                <tr
                                                                    key={souscription.id}
                                                                    className={`bg-white ${selectedSouscription && selectedSouscription.id === souscription.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(souscription)}
                                                                >
                                                                    <td>
                                                                        {souscription.utilisateur?.nom} {souscription.utilisateur?.prenoms}
                                                                        <div className='lesInfos'>
                                                                            <small>Formation: {souscription.formation?.nom || 'Aucune'}</small>
                                                                            <small>Produit: {souscription.produit?.nom || 'Aucun'}</small>
                                                                            <small>Date: {new Date(souscription.date_souscription).toLocaleDateString()}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {souscription.formation?.nom || souscription.produit?.nom || ''}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">{new Date(souscription.date_souscription).toLocaleDateString()}</td>
                                                                    <td className="d-none d-md-table-cell">{parseInt(souscription.montant_paye || 0).toLocaleString('fr-FR')} FCFA HT</td>
                                                                    <td className="d-none d-md-table-cell">{parseInt(souscription.reste_a_payer || 0).toLocaleString('fr-FR')} FCFA HT</td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">Aucune souscription trouvée</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
  <tbody>
    <tr>
      <td colSpan="8" className="text-center p-5">
        <div className="d-flex justify-content-center align-items-center">
          <div className="spiner-example">
            <div className="sk-spinner sk-spinner-wave">
              <div className="sk-rect1 mr-1"></div>
              <div className="sk-rect2 mr-1"></div>
              <div className="sk-rect3 mr-1"></div>
              <div className="sk-rect4 mr-1"></div>
              <div className="sk-rect5"></div>
            </div>
          </div>
        </div>
        <div className="mt-2">Chargement des produits...</div>
      </td>
    </tr>
  </tbody>
                                                    )}
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstSouscription + 1} à ${Math.min(indexOfLastSouscription, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Detail Modal */}
            <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="lg">
                <Modal.Header className="bg-success text-white">
                    <Modal.Title className="d-flex align-items-center">
                        <FaInfoCircle className="mr-2" />
                        Détails complets de la souscription
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {detailData ? (
                        <div>
                            {/* Navigation par onglets avec état React */}
                            <ul className="nav nav-tabs mb-4" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('info')}
                                        type="button"
                                        role="tab"
                                    >
                                        <FaInfoCircle className="mr-2" />
                                        Informations
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === 'paiements' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('paiements')}
                                        type="button"
                                        role="tab"
                                    >
                                        <FaMoneyBill className="mr-2" />
                                        Journal des paiements
                                    </button>
                                </li>
                            </ul>

                            {/* Contenu des onglets */}
                            <div className="tab-content">
                                {/* Onglet Informations */}
                                <div className={`tab-pane ${activeTab === 'info' ? 'show active' : 'fade'}`} role="tabpanel">
                                    <div className="row">
                                        {/* Section Utilisateur */}
                                        <div className="col-md-6 mb-4">
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0 d-flex align-items-center">
                                                        <FaUser className="mr-2" />
                                                        Informations utilisateur
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Nom complet:</span>
                                                        <span className="text-muted">
                                                            {detailData.utilisateur?.nom} {detailData.utilisateur?.prenoms}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Email:</span>
                                                        <span className="text-muted">{detailData.utilisateur?.email}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Téléphone:</span>
                                                        <span className="text-muted">{detailData.utilisateur?.tel}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-bold">Partenaire:</span>
                                                        <span className="text-muted">
                                                            {detailData.utilisateur?.partenaire_info?.createur_nom || 'Aucun'} ({detailData.utilisateur?.partenaire_info?.pourcentage_partenariat ? `${detailData.utilisateur?.partenaire_info?.pourcentage_partenariat}%` : ''})
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Section Financière */}
                                        <div className="col-md-6 mb-4">
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0 d-flex align-items-center">
                                                        <FaMoneyBill className="mr-2" />
                                                        Détails financiers
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Montant total:</span>
                                                        <span className="text-muted">
                                                            {parseInt(detailData.prix_final || 0).toLocaleString('fr-FR')} FCFA HT
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Montant payé:</span>
                                                        <span className="text-success fw-bold">
                                                            {parseInt(detailData.montant_paye || 0).toLocaleString('fr-FR')} FCFA HT
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                        <span className="fw-bold">Reste à payer:</span>
                                                        <span className="text-danger fw-bold">
                                                            {parseInt(detailData.reste_a_payer || 0).toLocaleString('fr-FR')} FCFA HT
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-bold">Bénéfice du partenaire:</span>
                                                        <span className="text-primary fw-bold">
                                                            {parseInt(detailData.montant_a_ceder - detailData.montant_de_reduction || 0).toLocaleString('fr-FR')} FCFA HT
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Détails Souscription */}
                                        <div className="col-12 mb-4">
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0 d-flex align-items-center">
                                                        <FaList className="mr-2" />
                                                        Détails de la souscription
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                                <span className="fw-bold">Type:</span>
                                                                <span className="text-muted">
                                                                    {detailData.formation ? 'Formation' : 'Produit'}
                                                                </span>
                                                            </div>
                                                            <div className="d-flex justify-content-between">
                                                                <span className="fw-bold">Nom:</span>
                                                                <span className="text-muted">
                                                                    {detailData.formation?.nom || detailData.produit?.nom}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="d-flex justify-content-between border-bottom pb-2 mb-3">
                                                                <span className="fw-bold">Date souscription:</span>
                                                                <span className="text-muted">
                                                                    {new Date(detailData.date_souscription).toLocaleDateString()}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Onglet Journal des paiements */}
                                <div className={`tab-pane ${activeTab === 'paiements' ? 'show active' : 'fade'}`} role="tabpanel">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h5 className="mb-0 d-flex align-items-center">
                                                {/* <FaHistory className="mr-2" /> */}
                                                Historique des paiements
                                            </h5>
                                        </div>
                                        <div className="card-body p-0">
                                            {detailData.paiements && detailData.paiements.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table table-sm table-hover mb-0">
                                                        <thead className="bg-light">
                                                            <tr>
                                                                <th className="ps-3">Date</th>
                                                                <th>Type de versement</th>
                                                                <th>Montant</th>
                                                                <th>Reste à payer</th>
                                                                <th className="pe-3">Enregistré par</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {detailData.paiements.map((paiement) => (
                                                                <tr key={paiement.id}>
                                                                    <td className="ps-3">
                                                                        {new Date(paiement.date_paiement).toLocaleDateString()}
                                                                    </td>
                                                                    <td>
                                                                        {paiement.versement === 'total' && (
                                                                            <span className="badge bg-primary">
                                                                                <FaCheckCircle className="mr-1" /> Totalité
                                                                            </span>
                                                                        )}
                                                                        {paiement.versement === 'premiere_tranche' && (
                                                                            <span className="badge bg-warning">
                                                                                <FaPercentage className="mr-1" /> 1ère tranche
                                                                            </span>
                                                                        )}
                                                                        {paiement.versement === 'deuxieme_tranche' && (
                                                                            <span className="badge bg-warning">
                                                                                <FaPercentage className="mr-1" /> 2ème tranche
                                                                            </span>
                                                                        )}
                                                                        {paiement.versement === 'troisieme_tranche' && (
                                                                            <span className="badge bg-warning">
                                                                                <FaPercentage className="mr-1" /> 3ème tranche
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-success fw-bold">
                                                            {parseInt(paiement.montant || 0).toLocaleString('fr-FR')} FCFA HT
                                                                    </td>
                                                                    <td>
                                                            {parseInt(paiement.reste_a_payer || 0).toLocaleString('fr-FR')} FCFA HT
                                                                    </td>
                                                                    <td className="pe-3">
                                                                        <small className="text-muted">
                                                                            {paiement.ajouter_par || 'Système'}
                                                                        </small>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="text-center py-5">
                                                    <FaMoneyBill size={40} className="text-muted mb-3" />
                                                    <h5 className="text-muted">Aucun paiement enregistré</h5>
                                                    <p className="text-muted">
                                                        Aucun paiement n'a été effectué pour cette souscription.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Résumé financier */}
                                    {detailData.paiements && detailData.paiements.length > 0 && (
                                        <div className="row mt-4">
                                            <div className="col-md-4">
                                                <div className="card border-0 bg-light">
                                                    <div className="card-body text-center">
                                                        <h6 className="card-title text-muted">Total payé</h6>
                                                        <h4 className="text-success fw-bold">
                                                            {detailData.montant_paye} FCFA HT
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card border-0 bg-light">
                                                    <div className="card-body text-center">
                                                        <h6 className="card-title text-muted">Reste à payer</h6>
                                                        <h4 className="fw-bold">
                                                            {detailData.reste_a_payer} FCFA HT
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="card border-0 bg-light">
                                                    <div className="card-body text-center">
                                                        <h6 className="card-title text-muted">Nombre de paiements</h6>
                                                        <h4 className="text-primary fw-bold">
                                                            {detailData.paiements.length}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </div>
                            <p className="mt-2">Chargement des détails...</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top-0">
                    <Button variant="secondary" onClick={handleCloseDetailModal} className="d-flex align-items-center">
                        Fermer
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => selectedSouscription && handleJournalPaiement(selectedSouscription)}
                        className="d-flex align-items-center"
                    >
                        <FaMoneyBill className="mr-2" />
                        Voir le journal complet
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ListeSouscriptionsAdmin;